import FinanceApi from '@/services/FinanceApi';
import Api from "@/services/Index";

const report = async (config) => {
    return FinanceApi.get('/invoices/report', config);
}

const reportJob = async (config) => {
    return FinanceApi.get('/invoices/report-job', config);
}

const myInvoices = async () => {
    return FinanceApi.get('/customer/invoices');
}

const customerInvoices = async (config) => {
    return FinanceApi.get('/customer/invoices', config);
}

const downloadInvoice = async (id) => {
    return FinanceApi.get('/customer/download-invoice/' + id, { responseType: 'arraybuffer' });
}

export default {
    report,customerInvoices,reportJob,myInvoices,downloadInvoice
}
